import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { obtenerVenta, limpiarVenta } from '../../actions/recibos';

import { formatNumber } from '../../utils/generalFunctions';

const Inicio = () => {

    const dispatch = useDispatch();

    const { folio } = useParams();

    const { recibo } = useSelector(state => state.recibos);

    const [ventaData, setVentaData] = useState({
        id: null,
        folio: null,
        cliente: null, 
        metodos: [], 
        fecha: null, 
        status: 0, 
        total: 0, 
        productos: [], 
        servicios: [], 
        medicos: []
    });

    const [tabActivo, setTabActivo] = useState('productos');

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columnsProductos = [
        {
            name: 'Producto',
            cell: row => row.producto?.nombre || 'Sin definir',
            grow: 2
        }, 
        {
            name: 'Cantidad',
            cell: row => formatNumber(row.cantidad, 0, '', '')
        },
        {
            name: 'Unidad',
            cell: row => row.unidad?.nombre || 'Sin definir'
        },
        {
            name: 'Paciente',
            cell: row => row.paciente?.nombre || 'Sin definir'
        },
        {
            name: 'Precio unitario',
            cell: row => formatNumber((row.precio != null && row.precio != undefined ? parseFloat(row.precio) : parseFloat(row.producto?.precio_venta)) / row.conversion, 2, '$ ', '')
        },
        {
            name: 'Importe',
            cell: row => formatNumber(((row.precio != null && row.precio != undefined ? parseFloat(row.precio) : parseFloat(row.producto?.precio_venta)) / row.conversion) * parseFloat(row.cantidad), 2, '$ ', '')
        }
    ];

    const columnsServicios = [
        {
            name: 'Servicio',
            cell: row => row.servicio?.nombre || 'Sin definir',
            grow: 4
        },
        {
            name: 'Cantidad',
            cell: row => formatNumber(row.cantidad, 0, '', '')
        },
        {
            name: 'Paciente',
            cell: row => row.paciente?.nombre || 'Sin definir'
        },
        {
            name: 'Precio unitario',
            cell: row => formatNumber(row.precio, 2, '$ ', '')
        },
        {
            name: 'Importe',
            cell: row => formatNumber(parseFloat(row.precio) * (row.cantidad ? parseFloat(row.cantidad) : 1), 2, '$ ', '')
        }
    ];

    const columnsMedicos = [
        {
            name: 'Nombre',
            cell: row => row.medico?.nombre || 'Sin definir',
            grow: 1.5
        }, 
        {
            name: 'Apellido',
            cell: row => row.medico?.apellido || 'Sin definir',
            grow: 1.5
        }, 
        {
            name: 'Cédula',
            cell: row => row.medico?.cedula_licenciatura || 'Sin definir'
        }, 
        {
            name: 'Especialidad',
            cell: row => row.medico?.especialidad || 'Sin definir', 
            grow: 2
        }, 
        {
            name: 'Cédula de especialidad',
            cell: row => row.medico?.cedula_especialidad || 'Sin definir'
        }, 
    ];

    useEffect(() => {
        return () => {
            dispatch(limpiarVenta());
        }
    }, []);

    useEffect(() => {
        if(folio){
            if(folio.length == 6){
                dispatch(obtenerVenta(folio));
            }else{

            }
        }else{

        }
    }, [folio]);

    useEffect(() => {
        if(recibo){
            setVentaData({
                ...ventaData,
                id: recibo?.id, 
                folio: recibo?.folio, 
                cliente: recibo?.cliente, 
                metodos: recibo?.metodos || [],
                fecha: recibo?.fecha, 
                status: recibo?.status, 
                total: recibo?.total,
                productos: recibo?.productos, 
                servicios: recibo?.servicios, 
                medicos: recibo?.medicos
            });
        }
    }, [recibo]);

    return (
        <main className="main">
            {
                recibo ? 
                    <section id="hero" className="hero section">
                        <div className="container py-4 receipt-view">

                            {/* Header */}
                            <div className="text-center mb-4">
                                <img className="logo-header" src="/assets/images/isotipo-color.png" alt="" />
                                <p className="text-muted mb-0">Recibo digital de compra</p>
                            </div>

                            {/* Total + Status */}
                            <div className="card receipt-total mb-4">
                                <div className="card-body text-center">
                                    <span className="badge receipt-status mb-2">Venta realizada</span>
                                    <h2 className="fw-bold mb-0">{formatNumber((ventaData?.total || 0), 2, '$ ', '')}</h2>
                                    <small className="receipt-label">Total pagado</small>
                                </div>
                            </div>

                            {/* Información general */}
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-12 col-md-4">
                                            <label className="fw-bold">Cliente</label>
                                            <p className="mb-0">{ventaData?.cliente?.nombre ? ventaData?.cliente?.nombre + ' ' + ventaData?.cliente?.apellido : 'Público general'}</p>
                                        </div>

                                        <div className="col-12 col-md-1">
                                            <label className="fw-bold">Folio</label>
                                            <p className="mb-0">{ventaData?.folio || 'Sin definir'}</p>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <label className="fw-bold">Fecha</label>
                                            <p className="mb-0">{ventaData?.fecha && ventaData?.fecha != '0000-00-00' ? new Date(ventaData?.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' a las ' + new Date(ventaData?.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'}</p>
                                        </div>

                                        <div className="col-12 col-md-3">
                                            <label className="fw-bold">Método de pago</label>
                                            <p className="mb-0">
                                                {
                                                    ventaData?.metodos?.length > 0
                                                        ? (() => {
                                                            const nombres = ventaData.metodos
                                                                .map(m => m.metodo?.nombre)
                                                                .filter(Boolean);

                                                            if (nombres.length === 1) {
                                                                return nombres[0];
                                                            }

                                                            if (nombres.length === 2) {
                                                                return `${nombres[0]} y ${nombres[1]}`;
                                                            }

                                                            return `${nombres.slice(0, -1).join(', ')} y ${nombres[nombres.length - 1]}`;
                                                        })()
                                                        : 'Sin definir'
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Tabs */}
                            <ul className="nav nav-tabs custom-tabs mb-3">
                                <li className="nav-item">
                                    <button className={`nav-link ${tabActivo === 'productos' ? 'active' : ''}`} onClick={() => setTabActivo('productos')} type="button">
                                        Productos <span className="badge ms-2">{ventaData.productos.length}</span>
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link ${tabActivo === 'servicios' ? 'active' : ''}`} onClick={() => setTabActivo('servicios')} type="button">
                                        Servicios <span className="badge ms-2">{ventaData.servicios.length}</span>
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link ${tabActivo === 'medicos' ? 'active' : ''}`} onClick={() => setTabActivo('medicos')} type="button">
                                        Médicos <span className="badge ms-2">{ventaData.medicos.length}</span>
                                    </button>
                                </li>
                            </ul>

                            {/* Contenido del tab */}
                            <div className="card mb-4">
                                <div className="card-body p-0">
                                    {tabActivo === 'productos' && (
                                        <DataTable
                                            columns={columnsProductos}
                                            data={ventaData.productos}
                                            pagination
                                            paginationPerPage={20}
                                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                            paginationComponentOptions={paginationOptions}
                                            highlightOnHover={true}
                                            noDataComponent={<div className="py-4 text-center text-muted">No hay productos para mostrar</div>}
                                        />
                                    )}
                                    
                                    {tabActivo === 'servicios' && (
                                        <DataTable
                                            columns={columnsServicios}
                                            data={ventaData.servicios}
                                            pagination
                                            paginationPerPage={20}
                                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                            paginationComponentOptions={paginationOptions}
                                            highlightOnHover={true}
                                            noDataComponent={<div className="py-4 text-center text-muted">No hay servicios para mostrar</div>}
                                        />
                                    )}

                                    {tabActivo === 'medicos' && (
                                        <DataTable
                                            columns={columnsMedicos}
                                            data={ventaData.medicos}
                                            pagination
                                            paginationPerPage={20}
                                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                                            paginationComponentOptions={paginationOptions}
                                            highlightOnHover={true}
                                            noDataComponent={<div className="py-4 text-center text-muted">No hay médicos para mostrar</div>}
                                        />
                                    )}
                                </div>
                            </div>

                            {/* Datos fiscales */}
                            <div className="card mb-4">
                                <div className="card-header fw-bold">
                                    Datos fiscales
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-12 col-md-5">
                                            <p className="mb-1"><strong>Dirección:</strong> Av. Aguascalientes #503, Boulevares 1ª Sección, CP 20288</p>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <p className="mb-1"><strong>Contacto:</strong> 449 978 0234 · 449 913 6041</p>
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <p className="mb-0"><strong>Email:</strong> recepcion.tostes@gmail.com</p>
                                        </div>
                                        <div className="col-12 col-md-5">
                                            <p className="mb-1"><strong>Razón social:</strong> María Guadalupe Torres Soto</p>
                                        </div>
                                        <div className="col-12 col-md-7">
                                            <p className="mb-1"><strong>RFC:</strong> TOSG750509GD7</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="text-center text-muted">
                                <small><b>Gracias por su preferencia</b></small>
                            </div>

                        </div>
                    </section>
                :
                    <section id="error-404" class="error-404 section">
                        <div class="container" data-aos="fade-up" data-aos-delay="100">
                            <div class="error-wrapper">
                                <div class="row align-items-center">
                                    <div class="col-lg-6" data-aos="fade-right" data-aos-delay="200">
                                        <div class="error-illustration">
                                            <i class="bi bi-exclamation-triangle-fill"></i>
                                            <div class="circle circle-1"></div>
                                            <div class="circle circle-2"></div>
                                            <div class="circle circle-3"></div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6" data-aos="fade-left" data-aos-delay="300">
                                        <div class="error-content">
                                            <img className="logo-404 my-3" src="/assets/images/isotipo-color.png" data-aos="fade-up" data-aos-delay="500" alt="" />
                                            <h2 class="error-title" data-aos="fade-up" data-aos-delay="600">Venta no encontrada</h2>
                                            <p class="error-description" data-aos="fade-up" data-aos-delay="700">La venta que intentas encontrar con el folio <b>{folio}</b> no existe, verifica tu folio nuevamente o intentalo más tarde.</p>

                                            <div class="error-actions" data-aos="fade-up" data-aos-delay="800">
                                                <a href="/" class="btn-home">
                                                    <i class="bi bi-house-door"></i> Conócenos
                                                </a>
                                                <a href="/busqueda" class="btn-help">
                                                    <i class="bi bi-question-circle"></i> Buscar nuevamente
                                                </a>
                                            </div>

                                            <div class="error-suggestions" data-aos="fade-up" data-aos-delay="900">
                                                <h3>Tambíen podrías:</h3>
                                                <ul>
                                                    <li><a href="#"><i class="bi bi-arrow-right-circle"></i> Contactarnos vía WhatsApp</a></li>
                                                    <li><a href="#"><i class="bi bi-arrow-right-circle"></i> Contactarnos vía telefónica</a></li>
                                                    <li><a href="#"><i class="bi bi-arrow-right-circle"></i> Visitar nuestras instalaciones</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
            }
        </main>
    )
}

export default Inicio;